import { useState, useEffect } from 'react';
import { getProjectsForClient } from '../api/scan-api';
import { Project } from '../types';

export const useProjects = (clientId: string | null) => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!clientId) {
      setProjects([]);
      return;
    }

    const loadProjects = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const data = await getProjectsForClient(parseInt(clientId));
        setProjects(data);
      } catch (err) {
        console.error('Error loading projects:', err);
        setError('Failed to load projects');
      } finally {
        setIsLoading(false);
      }
    };

    loadProjects();
  }, [clientId]);

  return { projects, isLoading, error };
};

